import sideImage from 'assets/ttu/ttu-step-1.avif';
import React, { useEffect, useState } from 'react';
import './styles.less';
import { useGlobal } from 'context';
import dayjs from 'dayjs';
import { ComboBox } from 'components/ComboBox';
import entheaNetwork from 'utils/enthea-network';
import { withLayout } from 'helpers';
import { useTracker } from 'utils/tracking';
import { StepButtons } from '../components/StepButtons';
import { InputV2 } from 'components/InputV2';
import { StateSelectV2 } from 'components/StateSelectV2';
import { DateInput } from 'components/DateInput';
import { Grid } from '@mui/material';
import { SideImageContainer } from '../components/SideImageContainer';

const MIN_AGE = 18;
const MAX_AGE = 120;

const MIN_DATE = dayjs().subtract(MAX_AGE, 'year').toDate();
const MAX_DATE = dayjs().subtract(MIN_AGE, 'year').toDate();

function DateAndState(props) {
  // Hooks and global context
  const trackOnce = useTracker();
  const { startInfo, setStartInfo, availableStates } = useGlobal();

  // Local states
  const [state, setState] = useState(startInfo?.state);
  const [dateOfBirth, setDateOfBirth] = useState(startInfo?.dateOfBirth ?? '');
  const [zipCode, setZipCode] = useState(startInfo?.zipCode ?? '');
  const [entheaCompany, setEntheaCompany] = useState(startInfo?.entheaCompany);
  const [submitted, setSubmitted] = useState(false);

  // Specific logic for Enthea
  const isEntheaPartner = window.sessionStorage.enthea_partner;
  const filledEntheaCompany = !isEntheaPartner || entheaCompany;

  // Validation to enable the continue button
  const canContinue =
    dateOfBirth &&
    state &&
    zipCode.length === 5 &&
    filledEntheaCompany &&
    dateOfBirth > MIN_DATE &&
    dateOfBirth < MAX_DATE;

  useEffect(() => {
    return persistInfo;
  }, [dateOfBirth, state, zipCode, entheaCompany]);

  useEffect(() => {
    if (!availableStates?.length || !submitted) return;
    trackOnce('lead_question2_state_DOB_zip');

    props.history.push(
      availableStates.includes(state)
        ? props.availableRoute
        : props.unavailableRoute
    );
  }, [submitted, availableStates]);

  function persistInfo() {
    setStartInfo({
      ...startInfo,
      dateOfBirth,
      state,
      zipCode,
      entheaCompany,
    });
  }

  function onClickNext() {
    persistInfo();
    setSubmitted(true);
  }

  return (
    <SideImageContainer sideImage={sideImage}>
      <div className="header">
        <StepButtons
          onBack={() => props.history.push(props.prevRoute)}
          onNext={onClickNext}
          disableNext={!canContinue || submitted}
          loading={submitted}
        />
      </div>

      <div className="right-content">
        <div className="right-copy">
          {props.textContent || (
            <h2 className="blue label state_title">
              Before we begin, let's confirm we're available in your area
            </h2>
          )}
        </div>

        <Grid container spacing={1} className="inputs">
          <Grid item xs={12} md={4}>
            <DateInput
              value={dateOfBirth}
              onChange={(v) => setDateOfBirth(v)}
              minDate={MIN_DATE}
              maxDate={MAX_DATE}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <StateSelectV2
              required
              preferred={availableStates}
              label="State"
              name="state"
              value={state}
              onChange={(_e, { value }) => setState(value)}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <InputV2
              required
              label="Zip code"
              type="text"
              name="zip"
              value={zipCode}
              onKeyPress={(e) => {
                if (e.which < 48 || e.which > 57) {
                  e.preventDefault();
                }
              }}
              onChange={(_e, { value }) => {
                if (value.length > 5) return;
                setZipCode(value);
              }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            {isEntheaPartner && (
              <ComboBox
                label="Referred by"
                fallback="My employer is not showing"
                options={entheaNetwork}
                className="state_container"
                name="referred"
                value={entheaCompany}
                onChange={(_e, value) => setEntheaCompany(value)}
              />
            )}
          </Grid>
        </Grid>
      </div>
    </SideImageContainer>
  );
}

DateAndState.title = "Birthdate & Location | Nue Life";

export default withLayout(DateAndState);